<template>
  <div>
    <v-toolbar dense class="elevation-1">
      <v-icon color="green" class="text-h4">mdi-file-document</v-icon>
      <v-toolbar-title
        :style="
          $vuetify.breakpoint.smAndUp
            ? 'letter-spacing: 0.5rem'
            : 'letter-spacing: 0.2rem'
        "
        style="text-transform: uppercase"
        class="ml-3 font-weight-bold"
      >
        {{ $t('admin.admin_menu.menu34') }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn dark color="darkpink" rounded @click="toExercises()">
        <v-icon left> mdi-plus-thick </v-icon>
        {{ $t('botoes.botao_novo') }}
      </v-btn>
    </v-toolbar>
    <div class="text-h6 ma-4">{{ $t('homework.homework_kitaula') }}</div>
    <div class="mt-2 mx-10">
      <v-expansion-panels focusable>
        <v-expansion-panel v-for="kt in kits" :key="kt.id">
          <v-expansion-panel-header ripple @click="getClassByKits(kt.id)">
            {{ kt.name }}

            <template v-slot:actions>
              <v-icon color="darkblue"> $expand </v-icon>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-data-table
              :headers="headers"
              :items="classes"
              :search="search"
              :footer-props="{
                'items-per-page-options': [10, 20, 45, 60, -1],
                'items-per-page-all-text': $t('events.events_headers.headers1'),
                'items-per-page-text': $t('student.student_paginas'),
                'show-first-last-page': true,
              }"
              >
              <template v-slot:[`item.details`]="{ item }">
                <v-btn
                  small
                  outlined
                  rounded
                  color="darkblue"
                  class="px-2 mx-1"
                  @click="toEdit(item)"
                >
                  <v-icon small class="mr-1"> mdi-image </v-icon>
                  editar
                </v-btn>
                <v-btn
                  small
                  outlined
                  rounded
                  color="red"
                  class="px-2 mx-1"
                  @click="deleteSuport(item)"
                >
                  <v-icon small class="mr-1"> mdi-delete </v-icon>
                  {{ $t('botoes.botao_excluir') }}
                </v-btn>
              </template>
            </v-data-table>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
    <v-dialog
      v-model="dialogSummarie"
      transition="dialog-bottom-transition"
      width="55%"
      :fullscreen="$vuetify.breakpoint.mobile"
      persistent
    >
      <v-card class="rounded-lg">
        <v-card-title class="darkblue white--text"
          >{{ $t('homework.homework_titleaula') }}</v-card-title
        >
        <v-card-text class="px-6 pt-6">
          <v-img
            v-if="summ"
            class="rounded-lg mx-auto"
            :src="summ"
            max-height="450px"
          ></v-img>
          <span v-if="!summ" class="text--primary" style="font-size: 1.1rem">
            {{ $t('homework.homework_adicionarARQ') }}
          </span>
        </v-card-text>
        <v-card-actions class="pb-4">
          <v-spacer></v-spacer>
          <v-btn
            color="darkpink"
            class="px-3"
            text
            rounded
            :loading="isSelecting"
            @click="handleFileImport()"
          >
            <span v-if="summ">{{ $t('botoes.botao_edita') }}</span>
            <span v-if="!summ">{{ $t('botoes.botao_adicionar') }}</span>
          </v-btn>
          <input
            ref="uploader"
            class="d-none"
            type="file"
            @change="onFileChanged"
          />
          <v-btn
            color="darkpink"
            class="px-6 ml-3"
            dark
            rounded
            @click="closeSumm()"
          >
            {{ $t('botoes.botao_sair') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogExercises"
      transition="dialog-bottom-transition"
      width="55%"
      :fullscreen="$vuetify.breakpoint.mobile"
    >
      <v-card class="rounded-lg">
        <v-card-title class="darkblue white--text">
          {{ $t('homework.homework_exercise.exercise') }}
          <v-spacer></v-spacer>
          <v-btn
            rounded
            dark
            color="darkpink"
            @click="toEdit(exerc)"
            v-if="!noExerc"
          >
            <v-icon small class="mr-1">mdi-pencil</v-icon>
            {{ $t('botoes.botao_edita') }}
          </v-btn>
        </v-card-title>
        <v-card-text class="px-8 pt-6">
          <div v-for="(dat, i) in exerc" :key="dat.id">
            <div class="text-subtitle-1 black--text font-weight-medium mb-2">
              {{ i + 1 }}. {{ dat.content }}
            </div>
            <div v-if="dat.image != null">
              <v-img :src="dat.image" max-width="150px" class="mx-auto mb-2" />
            </div>
            <div
              class="text-body-1"
              :class="opt.correct ? 'green--text' : ''"
              v-for="(opt, index) in dat.option"
              :key="opt.id"
            >
              <div v-if="dat.type == 'M'">
                {{ index + 1 }}- {{ opt.content }}
                <v-icon v-if="opt.correct" small color="green"
                  >mdi-check</v-icon
                >
              </div>
              <div v-if="dat.type == 'I'">
                {{ index + 1 }}.
                <v-img
                  :aspect-ratio="2 / 1"
                  :src="opt.content"
                  width="250px"
                  :class="opt.correct ? 'correctImg' : ''"
                  class="mb-2"
                />
              </div>
              <div v-if="dat.type == 'B'">
                <span v-if="opt.correct" class="font-weight-bold">
                  R: {{ opt.content }}</span
                >
              </div>
            </div>
            <v-divider class="my-6"></v-divider>
          </div>
          <div v-if="noExerc" class="text--primary" style="font-size: 1.1rem">
            {{ $t('homework.homework_exercise.exercise_no') }}
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
    v-model="edit"
    persistent
    max-width="60%"
    :fullscreen="$vuetify.breakpoint.mobile"
  >
    <v-card class="rounded-lg">
      <v-card-title class="darkblue white--text">
        Editar
        <v-spacer></v-spacer>
        <v-btn icon text color="white" @click="edit=false">
          <v-icon> mdi-close </v-icon>
        </v-btn>
      </v-card-title>
      <br>
      <v-stepper v-model="editTool">
        <v-form ref="teste">
            <v-card>
              <v-row>
                <v-col cols="12">
                  <v-textarea
                    color="blue"
                    clearable
                    :rules="[rules.required]"
                    clear-icon="mdi-close-circle"
                    :label="$t('planoDeAula.plano_dados.objetivo')"
                    :hint="$t('planoDeAula.plano_descricao.objetivo')"
                    persistent-hint
                    filled
                    no-resize
                    rows="5"
                    v-model="editTool.conteudo"
                  >
                  </v-textarea>
                </v-col>
              </v-row>
              <v-card-actions class="d-flex justify-end">
                <v-btn
                  color="darkpink"
                  rounded
                  text
                  @click="saveBtn()"
                >
                  {{ $t('botoes.botao_salva') }}
                </v-btn>
              </v-card-actions>
            </v-card>
        </v-form>
      </v-stepper>
    </v-card>
  </v-dialog>
  </div>
</template>

<script>
const axios = require("axios");
const url = process.env.VUE_APP_API_URL;
const token = "Baerer " + localStorage.getItem("accessToken");

export default {
  data() {
    return {
      page: 1,
      pageCount: null,
      itemsPerPage: 25,
      dialogRegister: false,
      rules: {
        email: (v) => !!(v || "").match(/@/) || this.$t('regras.regra_email'),
        length: (len) => (v) =>
          (v || "").length >= len ||
          `${this.$t('regras.regra_senhaMini.senha1')} ${len} ${this.$t('regras.regra_senhaMini.senha2')}`,
        required: (v) => !!v || this.$t('regras.regra_obrigatorio'),
        option: (v) => !!v || this.$t('regras.regra_opcao'),
        file: (v) => !!v || this.$t('regras.regra_file'),
        image: (v) => !!v || this.$t('regras.regra_image'),
        question: (v) => !!v || this.$t('regras.regra_question'),
        date: (v) => !!v || this.$t('regras.regra_data'),
        none: true,
      },
      classes: [],
      description: null,
      noDataClass: this.$t('homework.homework_kit'),
      summary: null,
      classId: null,
      noExerc: false,
      kits: [],
      headers: [
        { text: this.$t('homework.homework_title'), value: "name" },
        { text: "", value: "details", sortable: false, align: "end" },
      ],
      dialogSummarie: false,
      dialogExercises: false,
      summ: null,
      isSelecting: false,
      selectedFile: null,
      exerc: null,
      allExerc: null,
      editTool: [],
      edit: false,
    };
  },
  created() {

    this.getKits();
  },
  methods: {
    handleFileImport() {
      this.isSelecting = true;

      window.addEventListener(
        "focus",
        () => {
          this.isSelecting = false;
        },
        { once: true }
      );

      this.$refs.uploader.click();
    },
    async onFileChanged(e) {
      let selected = e.target.files[0];
      let formData = new FormData();
      formData.append("file", selected, selected.name);
      let res = await axios.post(`${url}/lessonsExtras/files`, formData);
      this.summ = res.data.url;
      let data = { classId: this.classId, uri: this.summ };
      axios.post(`${url}/summaries`, data, {
        headers: {
          authorization: token,
        },
      });
    },
    getClassByKits(kitId) {
      axios
        .get(`${url}/teacherSupport/${kitId}`, {
          headers: {
            authorization: token,
          },
        })
        .then((res) => {
          this.classes = res.data;
          console.log(this.classes)
        })
        .catch((error) => {
          console.error(error);
        });

    },
    getKits() {
      axios
        .get(`${url}/basics/kits`, {
          headers: {
            authorization: token,
          },
        })
        .then((res) => {
          this.kits = res.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    toExercises() {
      this.$parent.$parent.$parent.exerciseId = null;
      this.$emit("message", "Exercícios");
      this.$parent.$parent.$parent.page = this.$t('admin.admin_menu.menu35');
    },
    closeSumm() {
      this.dialogSummarie = false;
      setTimeout(() => {
        this.summ = null;
      }, 500);
    },
    async seeSummaries(id) {
      console.log(id)
      window.open(id.url)
    },
    async deleteSuport(acesso) {
      axios
        .delete(
          `${url}/teacherSupport/${acesso.id}`,
          {
            headers: {
              authorization: token,
            },
          },
        )
        .then(() => {
          this.getClassByKits(acesso.idKits)
        })
        .catch((error) => {
          console.error(error);
        });
    },
    async saveBtn(){
      console.log(this.editTool)
      await axios.put(`${url}/teacherSupport/${this.editTool.id}`, this.editTool, {
          headers: {
            authorization: token,
          },
        });
      this.edit = false
    },
    toEdit(res) {
      //console.log(res)
      this.editTool = res
      this.edit = true
      let id = res[0].id;
      this.$parent.$parent.$parent.exerciseId = id;
      this.$emit("message", "Exercícios");
      this.$parent.$parent.$parent.page = this.$t('admin.admin_menu.menu35');
    },
  },
};
</script>

<style scoped>
.correctImg {
  border: 5px solid #468c00;
}
</style>
